import axios from 'axios';
import isFinite from 'lodash/isFinite';

const state = {
    enterprises: [],
    areas: [],
    segments: [],
    groups: [],
    enterpriseId: null,
    areaId: null,
    segmentId: null,
    groupId: null,
    date: '',
    end_date: '',
    payrollTypes: {},
    payrollType: null,
    loadingEnterprises: false,
    loadingAreas: false,
    loadingSegments: false,
    loadingGroups: false,
    type: null
};

const getters = {
    payrollTypeOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            Object.keys(state.payrollTypes).map(pt => ({value: pt, text: state.payrollTypes[pt]}))
        );
    },
    enterpriseOptions: state => {
        return [{ value: null, text: 'Seleccionar' }].concat(
            state.enterprises.map(p => {
                return { value: p.type, text: p.type_name }
            })
        );
    },
    enterprise: state => {
        if (state.enterpriseId !== null) {
            return state.enterprises.find(e => e.type == state.enterpriseId);
        }

        return null;
    }
};

const mutations = {
    setDate(state, date) {
        state.date = date;
    },
    setEndDate(state, endDate) {
        state.end_date = endDate;
    },
    setPayrollTypes(state, payrollTypes) {
        state.payrollTypes = payrollTypes;
    },
    setPayrollType(state, payrollType) {
        state.payrollType = payrollType;
    },
    setEnterprises(state, enterprises) {
        state.enterprises = enterprises;
    },
    setEnterpriseId(state, id) {
        state.enterpriseId = id;
    },
    setAreaId(state, id) {
        state.areaId = id;
    },
    setSegmentId(state, id) {
        state.segmentId = id;
    },
    setGroupId(state, id) {
        state.groupId = id;
    }
};

const actions = {
    loadEnterprises({state, commit, dispath}, { payrollType, reset = true }) {
        state.loadingEnterprises = true;

        axios.get(`/api/payroll-types/${payrollType}/enterprises`, {
            params: {
                date: state.date,
                source:'reports'
            }
        })
            .then(res => {
                commit('setEnterprises', [...res.data]);

                console.log('finding in ', state.enterprises)
                if (state.enterprises.findIndex(e => e.id == state.enterpriseId) === -1)
                    commit('setEnterpriseId', null);

                state.loadingEnterprises = false;
            });
    },
    init({ commit, dispatch }) {
        commit('setDate', date)
        commit('setEndDate', end_date)
        commit('setPayrollTypes', payrollTypes)

        if (payrollType) {
            commit('setPayrollType', payrollType)
            dispatch('loadEnterprises', { payrollType, reset: false });
        }

        if (typeof enterprise !== 'undefined' && isFinite(parseInt(enterprise))) {
            commit('setEnterpriseId', enterprise)
        }

    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
